/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import { IGetServicesListProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "HolderServicesPageService";
const log: any = LoggerModule.getInstance();

export class HolderServicesPageService {
  private static instance: HolderServicesPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): HolderServicesPageService {
    if (!HolderServicesPageService.instance) {
      HolderServicesPageService.instance = new HolderServicesPageService(props);
    }
    return HolderServicesPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IGetServicesListProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getAppCardListProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
